import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const OutdoorSports = () => (
  <div>
    <h2>Outdoor Sports</h2>
    <p>6 Channels of Premium Outdoor Sports Content in HD. $3</p>
    <Button outline color="success" id="outdoorsportstoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#outdoorsportstoggle">
      <Card>
        <CardBody>
          330 - Outdoor Channel<br />
          331 - Sportsman Channel<br />
          332 - World Fishing Network<br />
          333 - Pursuit<br />
          339 - TVG2<br />
          341 - MAV TV<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default OutdoorSports;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/outdoorsports.js